import { Typography } from "@shared/ui.primitives";
import React from "react";

import { productRibbon, productRibbonCopy } from "./ProductRibbon.css";

export type Props = {
  ribbonKey: string;
  text: string;
};

type AllowedRibbonColours = "lightGrey" | "yellow" | "pink" | "default";

const colorMap: { [key: string]: AllowedRibbonColours } = {
  newIn: "lightGrey",
  comingSoon: "lightGrey",
  limitedEdition: "pink",
  moreStockComingSoon: "pink",
  lastCall: "lightGrey",
  backInStock: "pink",
  lowStock: "lightGrey",
  // TODO: still waiting for feedback on the below
  outOfStock: "lightGrey",
  bestSeller: "yellow"
};

export const ProductRibbon: React.FC<Props> = ({ ribbonKey, text }) => {
  const ribbonColor = colorMap[ribbonKey] || "default";

  return (
    <div data-testid="ribbon-wrapper" className={productRibbon[ribbonColor]}>
      <div className={productRibbonCopy}>
        <Typography variant="smallprint-sm-bold">{text}</Typography>
      </div>
    </div>
  );
};
